import Vue from 'vue'
import Vuex from 'vuex'
import menus from "@/store/modules/menus";

Vue.use(Vuex)

//从本地初始化患者草稿数据
let localPatientDraftList = localStorage.getItem('patientDraftList')
let patientDraftList = []
if (localPatientDraftList){
  patientDraftList = JSON.parse(localPatientDraftList)
}
//从本地初始化病历草稿数据
let localMedicalRecordDraftList = localStorage.getItem('medicalRecordDraftList')
let medicalRecordDraftList = []
if (localMedicalRecordDraftList){
  medicalRecordDraftList = JSON.parse(localMedicalRecordDraftList)
}

export default new Vuex.Store({
  state: {
    token: '',
    stopChange:false,
    patientDraftList:patientDraftList,
    medicalRecordDraftList:medicalRecordDraftList,
    nowPatientInfo:{}, //当前选中的患者信息
    nowMedicalRecordDraft:{}, //当前选中的患者信息
    isChangeLeftListBar: false, //是否切换左侧列表栏
    notActive: false, //是否处于非激活状态
    resetList: null, //是否重置列表
    activeFirst: false, //是否激活第一个患者
    aiDiagnosisList: [], // AI诊断结果列表
    zcPatient: null, //用于存储选中的患者信息
    patientInfoFormRuleType : 1, //1 专家审核 提交预诊 保存病历 完成病历  2 AI诊断
    nowRegisterInfo: null, //当前挂号信息,
    hospitalIsUpdate: false,
  },
  getters:{
    //获取草稿病历信息
    getNowMedicalRecordDraftByDraftId: (state) => (patient) => {
      return state.medicalRecordDraftList.find(item => item.draftId === patient.draftId)
    }
  },
  mutations: {
    //设置选中患者信息
    setNowPatientInfo (state,patientInfo) {
      state.nowPatientInfo = patientInfo
    },
    // 新增患者草稿
    addPatientDraft(state, patient) {
      if (patient && patient.draftId) {
        // 检查是否已存在相同 draftId 的草稿
        const exists = state.patientDraftList.some(
            item => item.draftId === patient.draftId
        );

        if (!exists) {
          // 使用 unshift 添加到数组开头（unshift是响应式的）
          state.patientDraftList.unshift(patient);

          // 持久化到 localStorage
          localStorage.setItem(
              'patientDraftList',
              JSON.stringify(state.patientDraftList)
          );
        } else {
          // 如果已存在，可以选择抛出错误或调用更新方法
          console.warn(`Draft with ID ${patient.draftId} already exists`);
          // 或者自动转为更新操作
          // Vue.set(state.patientDraftList, index, patient);
        }
      }
    },
    // 删除患者草稿
    deletePatientDraft(state, draftId) {
      console.log('store删除了草稿患者数据',draftId);
      
      if (draftId) {
        const index = state.patientDraftList.findIndex(
            item => item.draftId === draftId
        );

        if (index !== -1) {
          // 使用 splice 确保响应式更新
          state.patientDraftList.splice(index, 1);
          console.log('store删除了草稿患者数据2',draftId, state.patientDraftList);
          // 持久化到 localStorage
          localStorage.setItem(
              'patientDraftList',
              JSON.stringify(state.patientDraftList)
          );
        }
        console.log(state.patientDraftList);
        
      }
    },
    //更新患者草稿
    updatePatientByDraftId(state, patient) {
      console.log('11111')
      if (patient && patient.draftId) {
        const index = state.patientDraftList.findIndex(
            item => item.draftId === patient.draftId
        );

        if (index !== -1) {
          // 使用 Vue.set 确保响应式更新
          Vue.set(state.patientDraftList, index, patient);

          // 或者使用 splice 方法（也会触发响应式更新）
          // state.patientDraftList.splice(index, 1, patient);
        } else {
          // 可选：如果没有找到，可以添加新项目
          state.patientDraftList.push(patient);
        }

        // 如果需要立即持久化到 localStorage
        localStorage.setItem(
            'patientDraftList',
            JSON.stringify(state.patientDraftList)
        );
      }
    },
    // 新增病历草稿
    addMedicalRecordDraft(state, medicalRecordDraft) {
      if (medicalRecordDraft && medicalRecordDraft.draftId) {
        // 检查是否已存在相同 draftId 的草稿
        const exists = state.medicalRecordDraftList.some(
            item => item.draftId === medicalRecordDraft.draftId
        );

        if (!exists) {
          // 使用 push 添加新草稿（push 也是响应式的）
          state.medicalRecordDraftList.push(medicalRecordDraft);

          // 持久化到 localStorage
          localStorage.setItem(
              'medicalRecordDraftList',
              JSON.stringify(state.medicalRecordDraftList)
          );
        } else {
          // 如果已存在，可以选择抛出错误或调用更新方法
          console.warn(`Draft with ID ${medicalRecordDraft.draftId} already exists`);
          // 或者自动转为更新操作
          // Vue.set(state.patientDraftList, index, patient);
        }
      }
    },
    // 删除病历草稿
    deleteMedicalRecordDraft(state, draftId) {
      if (draftId) {
        const index = state.medicalRecordDraftList.findIndex(
            item => item.draftId === draftId
        );

        if (index !== -1) {
          // 使用 splice 删除（响应式）
          state.medicalRecordDraftList.splice(index, 1);

          // 持久化到 localStorage
          localStorage.setItem(
              'medicalRecordDraftList',
              JSON.stringify(state.medicalRecordDraftList)
          );
        } else {
          console.warn(`Draft with ID ${draftId} not found`);
        }
      }
    },
    // 更新病历草稿
    updateMedicalRecordDraft(state, medicalRecordDraft) {
      if (medicalRecordDraft && medicalRecordDraft.draftId) {
        const index = state.medicalRecordDraftList.findIndex(
            item => item.draftId === medicalRecordDraft.draftId
        );

        if (index !== -1) {
          // 使用 Vue.set 确保响应式更新
          Vue.set(state.medicalRecordDraftList, index, medicalRecordDraft);

          // 持久化到 localStorage
          localStorage.setItem(
              'medicalRecordDraftList',
              JSON.stringify(state.medicalRecordDraftList)
          );
        } else {
          console.warn(`Draft with ID ${medicalRecordDraft.draftId} not found`);
          // 可选：自动转为新增操作
          // state.medicalRecordDraftList.unshift(medicalRecordDraft);
        }
      }
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      sessionStorage.setItem("token", token);
    },
  },
  actions: {
  },
  modules: {
    menus
  }
})
